import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: '*',
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/EditorialContentPageContainer'),
  }),
};
